// copy of radix function: https://github.com/radix-ui/primitives/blob/main/packages/core/primitive/src/primitive.tsx
function composeEventHandlers(originalEventHandler, ourEventHandler) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$checkForDefaultP = _ref.checkForDefaultPrevented,
      checkForDefaultPrevented = _ref$checkForDefaultP === void 0 ? true : _ref$checkForDefaultP;

  return function handleEvent(event) {
    originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);

    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    }
  };
}

export { composeEventHandlers };